module.exports = __webpack_public_path__ + "img/liangzhounian.87f5c6e7.png";